import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import packageInfo from '../package.json';

if (environment.sentry) {
  enableProdMode();

  Sentry.init({
    dsn: 'https://056ced4ed3037b7561da8cf8a5366311@o4509300949385216.ingest.de.sentry.io/4509300977500240',
    release: `${packageInfo.name}@${packageInfo.version}`,
    sendDefaultPii: true,
    integrations: [
      Sentry.replayIntegration({
        networkDetailAllowUrls: [
          `${environment.backend}/${environment.version}/`
        ],
        maskAllText: false,
        blockAllMedia: false,
      }),
      Sentry.browserTracingIntegration()
    ],
    // Session Replay
    replaysSessionSampleRate: 0.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/api\.tyllt\.feelity\.dev/, /^https:\/\/api\.tyllt\.com/],
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));

defineCustomElements(window);
